// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
    :host {
      display: block;
      font-family: 'DM Sans', 'Segoe UI', system-ui, sans-serif;
    }

    /* ── Shell ── */
    .page-header {
      position: sticky;
      top: 0;
      z-index: 100;
      background: rgba(255, 255, 255, 0.92);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
      padding: 0 clamp(1rem, 4vw, 2rem);
      box-shadow: 0 1px 0 0 rgba(109, 74, 255, 0.08);
    }

    /* ── Inner layout ── */
    .header-inner {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 1rem;
      min-height: 60px;
      padding: 0.75rem 0;
    }

    /* ── Left ── */
    .header-left {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex: 1;
      min-width: 0;
      overflow: hidden;
    }

    /* ── Title ── */
    .title-block {
      display: flex;
      align-items: center;
      gap: 0.55rem;
      flex-shrink: 0;
    }

    .title-accent {
      display: inline-block;
      width: 3px;
      height: 20px;
      border-radius: 99px;
      background: linear-gradient(180deg, #6d4aff 0%, #a78bfa 100%);
      flex-shrink: 0;
    }

    .page-title {
      margin: 0;
      font-size: clamp(0.95rem, 2.5vw, 1.125rem);
      font-weight: 700;
      letter-spacing: -0.025em;
      color: #0f0a1e;
      white-space: nowrap;
      line-height: 1;
    }

    /* ── Divider ── */
    .header-left::after {
      content: '';
      display: block;
      width: 1px;
      height: 16px;
      background: #ddd8f0;
      flex-shrink: 0;
    }

    /* ── Breadcrumb ── */
    .breadcrumb-nav {
      min-width: 0;
      overflow: hidden;
    }

    .breadcrumb-list {
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
      align-items: center;
      gap: 0.25rem;
      flex-wrap: nowrap;
      overflow: hidden;
    }

    .breadcrumb-item {
      display: flex;
      align-items: center;
      gap: 0.25rem;
      min-width: 0;
    }

    /* Hide all but last two breadcrumb items on small screens */
    @media (max-width: 480px) {
      .breadcrumb-item:not(.breadcrumb-item--active):not(:nth-last-child(2)) {
        display: none;
      }

      .breadcrumb-item:nth-last-child(2) .breadcrumb-sep::before {
        content: '…';
        margin-right: 0.25rem;
      }
    }

    .breadcrumb-sep {
      font-size: 0.75rem;
      color: #c4bfda;
      -webkit-user-select: none;
              user-select: none;
      flex-shrink: 0;
    }

    .breadcrumb-text {
      font-size: 0.8125rem;
      font-weight: 400;
      color: #7c6fa0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition: color 0.15s ease;
      max-width: 160px;
    }

    .breadcrumb-item:not(.breadcrumb-item--active):hover .breadcrumb-text {
      color: #6d4aff;
      cursor: pointer;
    }

    .breadcrumb-item--active .breadcrumb-text {
      color: #1a1030;
      font-weight: 600;
      max-width: 200px;
    }

    /* ── Right slot ── */
    .header-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
    }

    /* ── Bottom rule ── */
    .header-rule {
      height: 1px;
      background: linear-gradient(
        90deg,
        rgba(109, 74, 255, 0.15) 0%,
        rgba(167, 139, 250, 0.1) 40%,
        transparent 100%
      );
    }

    /* ── Tablet: tighten up ── */
    @media (max-width: 768px) {
      .header-inner {
        min-height: 52px;
        gap: 0.75rem;
      }

      .title-accent {
        height: 18px;
      }

      .breadcrumb-text {
        max-width: 120px;
      }

      .breadcrumb-item--active .breadcrumb-text {
        max-width: 140px;
      }
    }

    /* ── Mobile: compact single-line ── */
    @media (max-width: 480px) {
      .header-inner {
        min-height: 48px;
        padding: 0.625rem 0;
      }

      .breadcrumb-text {
        font-size: 0.75rem;
        max-width: 90px;
      }

      .breadcrumb-item--active .breadcrumb-text {
        max-width: 110px;
      }
    }
  `, "",{"version":3,"sources":["webpack://./libs/ui/src/lib/components/sections/zikata-page-header/zikata-page-header.component.ts"],"names":[],"mappings":";IACI;MACE,cAAc;MACd,yDAAyD;IAC3D;;IAEA,gBAAgB;IAChB;MACE,gBAAgB;MAChB,MAAM;MACN,YAAY;MACZ,qCAAqC;MACrC,2BAA2B;MAC3B,mCAAmC;MACnC,iCAAiC;MACjC,8CAA8C;IAChD;;IAEA,uBAAuB;IACvB;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,SAAS;MACT,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA,eAAe;IACf;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT,OAAO;MACP,YAAY;MACZ,gBAAgB;IAClB;;IAEA,gBAAgB;IAChB;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,cAAc;IAChB;;IAEA;MACE,qBAAqB;MACrB,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,6DAA6D;MAC7D,cAAc;IAChB;;IAEA;MACE,SAAS;MACT,0CAA0C;MAC1C,gBAAgB;MAChB,wBAAwB;MACxB,cAAc;MACd,mBAAmB;MACnB,cAAc;IAChB;;IAEA,kBAAkB;IAClB;MACE,WAAW;MACX,cAAc;MACd,UAAU;MACV,YAAY;MACZ,mBAAmB;MACnB,cAAc;IAChB;;IAEA,qBAAqB;IACrB;MACE,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,SAAS;MACT,UAAU;MACV,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,YAAY;IACd;;IAEA,4DAA4D;IAC5D;MACE;QACE,aAAa;MACf;;MAEA;QACE,YAAY;QACZ,qBAAqB;MACvB;IACF;;IAEA;MACE,kBAAkB;MAClB,cAAc;MACd,yBAAiB;cAAjB,iBAAiB;MACjB,cAAc;IAChB;;IAEA;MACE,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,mBAAmB;MACnB,gBAAgB;MAChB,uBAAuB;MACvB,4BAA4B;MAC5B,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,gBAAgB;IAClB;;IAEA,qBAAqB;IACrB;MACE,aAAa;MACb,mBAAmB;MACnB,cAAc;IAChB;;IAEA,sBAAsB;IACtB;MACE,WAAW;MACX;;;;;OAKC;IACH;;IAEA,6BAA6B;IAC7B;MACE;QACE,gBAAgB;QAChB,YAAY;MACd;;MAEA;QACE,YAAY;MACd;;MAEA;QACE,gBAAgB;MAClB;;MAEA;QACE,gBAAgB;MAClB;IACF;;IAEA,sCAAsC;IACtC;MACE;QACE,gBAAgB;QAChB,mBAAmB;MACrB;;MAEA;QACE,kBAAkB;QAClB,eAAe;MACjB;;MAEA;QACE,gBAAgB;MAClB;IACF","sourcesContent":["\n    :host {\n      display: block;\n      font-family: 'DM Sans', 'Segoe UI', system-ui, sans-serif;\n    }\n\n    /* ── Shell ── */\n    .page-header {\n      position: sticky;\n      top: 0;\n      z-index: 100;\n      background: rgba(255, 255, 255, 0.92);\n      backdrop-filter: blur(12px);\n      -webkit-backdrop-filter: blur(12px);\n      padding: 0 clamp(1rem, 4vw, 2rem);\n      box-shadow: 0 1px 0 0 rgba(109, 74, 255, 0.08);\n    }\n\n    /* ── Inner layout ── */\n    .header-inner {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 1rem;\n      min-height: 60px;\n      padding: 0.75rem 0;\n    }\n\n    /* ── Left ── */\n    .header-left {\n      display: flex;\n      align-items: center;\n      gap: 1rem;\n      flex: 1;\n      min-width: 0;\n      overflow: hidden;\n    }\n\n    /* ── Title ── */\n    .title-block {\n      display: flex;\n      align-items: center;\n      gap: 0.55rem;\n      flex-shrink: 0;\n    }\n\n    .title-accent {\n      display: inline-block;\n      width: 3px;\n      height: 20px;\n      border-radius: 99px;\n      background: linear-gradient(180deg, #6d4aff 0%, #a78bfa 100%);\n      flex-shrink: 0;\n    }\n\n    .page-title {\n      margin: 0;\n      font-size: clamp(0.95rem, 2.5vw, 1.125rem);\n      font-weight: 700;\n      letter-spacing: -0.025em;\n      color: #0f0a1e;\n      white-space: nowrap;\n      line-height: 1;\n    }\n\n    /* ── Divider ── */\n    .header-left::after {\n      content: '';\n      display: block;\n      width: 1px;\n      height: 16px;\n      background: #ddd8f0;\n      flex-shrink: 0;\n    }\n\n    /* ── Breadcrumb ── */\n    .breadcrumb-nav {\n      min-width: 0;\n      overflow: hidden;\n    }\n\n    .breadcrumb-list {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n      flex-wrap: nowrap;\n      overflow: hidden;\n    }\n\n    .breadcrumb-item {\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n      min-width: 0;\n    }\n\n    /* Hide all but last two breadcrumb items on small screens */\n    @media (max-width: 480px) {\n      .breadcrumb-item:not(.breadcrumb-item--active):not(:nth-last-child(2)) {\n        display: none;\n      }\n\n      .breadcrumb-item:nth-last-child(2) .breadcrumb-sep::before {\n        content: '…';\n        margin-right: 0.25rem;\n      }\n    }\n\n    .breadcrumb-sep {\n      font-size: 0.75rem;\n      color: #c4bfda;\n      user-select: none;\n      flex-shrink: 0;\n    }\n\n    .breadcrumb-text {\n      font-size: 0.8125rem;\n      font-weight: 400;\n      color: #7c6fa0;\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      transition: color 0.15s ease;\n      max-width: 160px;\n    }\n\n    .breadcrumb-item:not(.breadcrumb-item--active):hover .breadcrumb-text {\n      color: #6d4aff;\n      cursor: pointer;\n    }\n\n    .breadcrumb-item--active .breadcrumb-text {\n      color: #1a1030;\n      font-weight: 600;\n      max-width: 200px;\n    }\n\n    /* ── Right slot ── */\n    .header-right {\n      display: flex;\n      align-items: center;\n      flex-shrink: 0;\n    }\n\n    /* ── Bottom rule ── */\n    .header-rule {\n      height: 1px;\n      background: linear-gradient(\n        90deg,\n        rgba(109, 74, 255, 0.15) 0%,\n        rgba(167, 139, 250, 0.1) 40%,\n        transparent 100%\n      );\n    }\n\n    /* ── Tablet: tighten up ── */\n    @media (max-width: 768px) {\n      .header-inner {\n        min-height: 52px;\n        gap: 0.75rem;\n      }\n\n      .title-accent {\n        height: 18px;\n      }\n\n      .breadcrumb-text {\n        max-width: 120px;\n      }\n\n      .breadcrumb-item--active .breadcrumb-text {\n        max-width: 140px;\n      }\n    }\n\n    /* ── Mobile: compact single-line ── */\n    @media (max-width: 480px) {\n      .header-inner {\n        min-height: 48px;\n        padding: 0.625rem 0;\n      }\n\n      .breadcrumb-text {\n        font-size: 0.75rem;\n        max-width: 90px;\n      }\n\n      .breadcrumb-item--active .breadcrumb-text {\n        max-width: 110px;\n      }\n    }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
